import api from './api';

const subscriptionsDashboardService = {
  // Get subscriptions dashboard statistics
  getDashboardStats: async () => {
    try {
      const response = await api.get('/subscriptions-dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching subscriptions dashboard stats:', error);
      throw error;
    }
  }
};

export default subscriptionsDashboardService;

